import {createStyles, InputBase, withStyles} from '@material-ui/core';
import {Theme} from 'feedback-system/with-root/typedef';

const styles = (theme: Theme) => createStyles({
    input: {
        'borderRadius': 4,
        'position': 'relative',
        'fontSize': '120%',
        'width': 'auto',
        'padding': '6px 26px 6px 0',
        '&:focus': {
            background: 'transparent'
        }
    }
});

const SelectInput = withStyles(styles)(InputBase);

export default SelectInput;
